import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { navLinks } from '@/constants/site'
import { PLACARD_LINE } from '@/constants/reverie'

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='px-[var(--rev-gutter)] pb-[clamp(30px,6vh,60px)]'>
            <div aria-hidden='true' className='h-px w-full bg-[var(--rev-hairline)]' />

            <div className='flex flex-col gap-[clamp(26px,5vh,44px)] pt-[clamp(24px,4vh,40px)] md:flex-row md:items-start md:justify-between'>
                <div className='flex flex-col gap-[8px]'>
                    <Link
                        href='/'
                        className='font-display text-[color:var(--rev-ink)] uppercase transition-opacity duration-500 hover:opacity-70'
                        style={{ fontSize: '12.5px', fontWeight: 600, letterSpacing: '0.34em' }}
                    >
                        Reverie
                    </Link>

                    <span className='rev-note text-[color:var(--rev-ink-faint)]'>
                        a collection of mornings that never happened
                    </span>
                </div>

                <nav aria-label='Footer' className='flex flex-wrap gap-x-[26px] gap-y-[10px]'>
                    {navLinks.map(link => (
                        <Link
                            key={link.href}
                            href={link.href}
                            className='rev-mark text-[color:var(--rev-ink-dim)] transition-opacity duration-500 hover:opacity-100'
                        >
                            {link.label}
                        </Link>
                    ))}

                    <a
                        href='mailto:hello@reverie.studio'
                        className='rev-mark text-[color:var(--rev-ink-dim)] transition-opacity duration-500 hover:opacity-100'
                    >
                        hello@reverie.studio
                    </a>
                </nav>
            </div>

            <div className='mt-[clamp(30px,6vh,56px)] flex flex-col gap-[10px] md:flex-row md:items-center md:justify-between'>
                <span
                    className='rev-mark text-[color:var(--rev-ink-faint)]'
                >
                    {PLACARD_LINE}
                </span>

                <span
                    className='rev-mark text-[color:var(--rev-ink-faint)]'
                >
                    All frames generated. None photographed.
                </span>
            </div>
        </footer>
    )
}
